import { WaitingModal } from "../WaitingModal";

interface TransfersWaitingModalProps {
  isOpen: boolean;
  onClose: () => void;
  txHash?: string;
  tokenSymbol?: string;
}

export function TransfersWaitingModal({ isOpen, onClose, txHash, tokenSymbol = "tokens" }: TransfersWaitingModalProps) {
  return (
    <WaitingModal
      isOpen={isOpen}
      onClose={onClose}
      title={`Transferring your ${tokenSymbol}...`}
      description="The transaction is being processed. You can stay or close the modal and we will notify you when the transaction is complete."
      txHash={txHash}
    />
  );
}
